module.exports = __webpack_public_path__ + "img/play.415c3995.svg";